module.exports = __webpack_public_path__ + "static/media/fellowship_img.45244871.png";